var _circle, _circle2, _g, _circle3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNetworkImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 284,
    viewBox: "0 0 280 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132.143,
    cy: 182.973,
    r: 97.6601,
    fill: "white",
    fillOpacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.143,
    cy: 182.973,
    r: 96.5376,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2.24506
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7214_8258)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.8354,
    cy: 6.83973,
    rx: 6.8354,
    ry: 6.83973,
    transform: "matrix(-1 0 0 1 154.912 22.3828)",
    fill: "#004E9A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.9712,
    cy: 4.97435,
    rx: 4.9712,
    ry: 4.97435,
    transform: "matrix(-1 0 0 1 30.6328 118.141)",
    fill: "#004E9A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7214_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.855 70.2616C218.855 73.7294 221.665 76.5401 225.129 76.5401C228.594 76.5401 231.404 73.7294 231.404 70.2616C231.404 66.7938 228.594 63.9831 225.129 63.9831C221.665 63.9831 218.855 66.7938 218.855 70.2616Z",
    stroke: "#004E9A",
    strokeOpacity: 0.3,
    strokeWidth: 1.12253
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7214_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.568 203.943C268.568 206.381 270.543 208.356 272.978 208.356C275.413 208.356 277.388 206.381 277.388 203.943C277.388 201.505 275.413 199.53 272.978 199.53C270.543 199.53 268.568 201.505 268.568 203.943Z",
    stroke: "#004E9A",
    strokeOpacity: 0.3,
    strokeWidth: 1.12253
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.107,
    cy: 3.10897,
    rx: 3.107,
    ry: 3.10897,
    transform: "matrix(-1 0 0 1 105.199 47.25)",
    fill: "#004E9A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.107,
    cy: 3.10897,
    rx: 3.107,
    ry: 3.10897,
    transform: "matrix(-1 0 0 1 166.098 55.9609)",
    fill: "#004E9A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_7214_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.731 58.4431L51.7598 53.4688M56.731 58.4431L61.7022 53.4688M56.731 58.4431L51.7598 63.4174M56.731 58.4431L61.7022 63.4174",
    stroke: "#004E9A",
    strokeOpacity: 0.3,
    strokeWidth: 1.12253
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_7214_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.907 128.084L236.936 123.109M241.907 128.084L246.878 123.109M241.907 128.084L236.936 133.058M241.907 128.084L246.878 133.058",
    stroke: "#004E9A",
    strokeOpacity: 0.3,
    strokeWidth: 1.12253
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_7214_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.768 81.4547L190.953 69.6406",
    stroke: "#004E9A",
    strokeOpacity: 0.3,
    strokeWidth: 1.12253
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.2195 305.916C97.3837 306.619 95.3447 306.568 93.5462 305.776C91.7477 304.983 90.3351 303.511 89.6156 301.681C82.3212 283.155 82.5092 265.08 90.163 249.416C99.5844 230.133 120.001 215.031 147.676 206.863C167.086 201.14 177.417 191.928 189.361 181.243C191.335 179.496 193.311 177.718 195.363 175.941C196.858 174.644 198.806 173.994 200.779 174.133C202.752 174.273 204.588 175.191 205.884 176.686C207.18 178.18 207.83 180.129 207.69 182.103C207.549 184.077 206.631 185.915 205.137 187.212C203.14 188.938 201.219 190.665 199.305 192.373C187.122 203.256 174.532 214.489 151.89 221.18C128.283 228.134 111.123 240.487 103.564 255.965C97.6445 267.962 97.6923 281.471 103.495 296.215C103.854 297.127 104.029 298.1 104.012 299.08C103.994 300.059 103.784 301.026 103.393 301.925C103.002 302.823 102.438 303.636 101.733 304.316C101.028 304.997 100.196 305.532 99.285 305.89L99.2195 305.916Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.984 185.906L213.895 206.906C211.885 208.659 209.262 209.54 206.602 209.358C203.943 209.175 201.466 207.943 199.715 205.932L176.066 178.768C174.315 176.757 173.435 174.133 173.618 171.472C173.802 168.811 175.034 166.332 177.044 164.579L201.134 143.579L237.957 185.875L237.984 185.906Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M237.984 185.906L213.895 206.906C211.885 208.659 209.262 209.54 206.602 209.358C203.943 209.175 201.466 207.943 199.715 205.932L176.066 178.768C174.315 176.757 173.435 174.133 173.618 171.472C173.802 168.811 175.034 166.332 177.044 164.579L201.134 143.579L237.957 185.875L237.984 185.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.392 152.931L201.148 143.571L237.986 185.892L227.235 195.265C226.095 194.779 225.081 194.037 224.274 193.096L192.14 156.166C191.314 155.238 190.715 154.131 190.392 152.931Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.911 145.078L232.854 146L238.985 153.043L240.042 152.121L233.911 145.078Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.009 141.62L219.979 131.234C218.44 129.477 216.399 128.233 214.131 127.671C211.863 127.109 209.477 127.255 207.295 128.09C206.052 128.562 204.903 129.251 203.901 130.126L197.058 136.095L196.129 135.039L202.985 129.065C204.11 128.084 205.399 127.31 206.794 126.78C209.248 125.847 211.929 125.687 214.476 126.321C217.024 126.956 219.316 128.355 221.045 130.331L230.074 140.716L229.009 141.62Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.549 189.354L249.623 180.645C252.914 177.799 253.277 172.823 250.435 169.531L217.783 131.714C214.94 128.422 209.967 128.06 206.676 130.905L196.602 139.615C193.311 142.46 192.947 147.436 195.79 150.729L228.442 188.545C231.285 191.837 236.257 192.2 239.549 189.354Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.947 147.694C216.493 148.322 216.84 149.098 216.945 149.924C217.051 150.75 216.908 151.588 216.537 152.333C216.165 153.079 215.581 153.697 214.858 154.11C214.135 154.522 213.306 154.712 212.476 154.653C211.646 154.594 210.852 154.29 210.195 153.78C209.537 153.269 209.046 152.575 208.784 151.785C208.521 150.995 208.498 150.145 208.719 149.342C208.94 148.539 209.393 147.82 210.023 147.275C210.865 146.546 211.961 146.181 213.072 146.259C214.182 146.338 215.216 146.854 215.947 147.694Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94 170.658C236.485 171.286 236.832 172.062 236.936 172.887C237.04 173.712 236.898 174.55 236.527 175.295C236.155 176.039 235.572 176.657 234.85 177.07C234.128 177.482 233.3 177.672 232.471 177.614C231.641 177.556 230.848 177.254 230.19 176.745C229.533 176.236 229.041 175.543 228.777 174.754C228.513 173.966 228.488 173.116 228.706 172.314C228.925 171.511 229.376 170.791 230.003 170.244C230.42 169.881 230.904 169.604 231.428 169.428C231.953 169.252 232.506 169.181 233.058 169.22C233.609 169.258 234.147 169.405 234.642 169.652C235.137 169.899 235.578 170.241 235.94 170.658Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4798 164.488C87.1169 163.416 89.0313 162.845 90.9879 162.846C92.9445 162.847 94.8584 163.419 96.4945 164.493C98.1306 165.567 99.4179 167.095 100.198 168.891C100.979 170.686 101.218 172.67 100.888 174.6C99.0347 184.786 96.8383 193.204 94.8753 200.58C90.1601 218.426 88.8493 225.048 94.3117 232.4C98.0127 236.715 102.106 240.677 106.538 244.234C118.412 254.557 131.852 266.238 132.859 282.158C133.408 290.712 130.166 298.991 123.215 306.779C121.429 308.706 118.959 309.854 116.336 309.979C113.713 310.103 111.146 309.193 109.186 307.444C107.226 305.695 106.03 303.247 105.854 300.625C105.678 298.004 106.536 295.417 108.245 293.422C113.103 287.898 112.924 284.544 112.881 283.393C112.396 275.886 101.884 266.717 93.4306 259.37C87.8713 254.89 82.7842 249.854 78.2486 244.339C66.7157 228.794 70.5947 214.073 75.5229 195.425C77.3663 188.379 79.4798 180.38 81.209 170.958C81.4535 169.649 81.9573 168.402 82.6908 167.291C83.4242 166.18 84.3725 165.227 85.4798 164.488Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.577 184.411L108.169 184.528C110.814 185.052 113.383 183.331 113.907 180.683L129.174 103.49C129.697 100.843 127.977 98.2718 125.332 97.7479L124.74 97.6307C122.094 97.1068 119.525 98.8281 119.001 101.475L103.734 178.669C103.211 181.316 104.931 183.887 107.577 184.411Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3992 176.472L67.9911 176.59C70.6366 177.114 73.2061 175.393 73.7301 172.746L89.0105 95.5551C89.5345 92.9079 87.8147 90.3369 85.1692 89.8125L84.5773 89.6952C81.9318 89.1708 79.3624 90.8917 78.8383 93.5389L63.5579 170.73C63.0339 173.377 64.7537 175.948 67.3992 176.472Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.781 141.93L123.014 196.32C122.669 198.063 121.985 199.72 121 201.198C120.015 202.676 118.748 203.945 117.273 204.933C115.798 205.921 114.142 206.609 112.401 206.957C110.661 207.305 108.868 207.306 107.127 206.961L59.6136 197.544C57.8721 197.199 56.2157 196.514 54.7388 195.528C53.262 194.542 51.9936 193.275 51.0061 191.799C50.0186 190.323 49.3314 188.666 48.9837 186.924C48.636 185.182 48.6345 183.389 48.9795 181.646L59.7465 127.255L133.781 141.93Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M133.781 141.93L123.014 196.32C122.669 198.063 121.985 199.72 121 201.198C120.015 202.676 118.748 203.945 117.273 204.933C115.798 205.921 114.142 206.609 112.401 206.957C110.661 207.305 108.868 207.306 107.127 206.961L59.6136 197.544C57.8721 197.199 56.2157 196.514 54.7388 195.528C53.262 194.542 51.9936 193.275 51.0061 191.799C50.0186 190.323 49.3314 188.666 48.9837 186.924C48.636 185.182 48.6345 183.389 48.9795 181.646L59.7465 127.255L133.781 141.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.125 160.782L133.866 141.954L59.8193 127.277L56.1046 146.111C57.4309 147.123 58.9731 147.815 60.6107 148.133L125.137 160.854C126.782 161.219 128.491 161.195 130.125 160.782Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57 146.369L139.838 145.018C140.975 139.274 137.243 133.695 131.502 132.557L65.5683 119.488C59.8278 118.351 54.2525 122.085 53.1154 127.829L52.8479 129.18C51.7108 134.924 55.4426 140.503 61.1831 141.641L127.117 154.709C132.858 155.847 138.433 152.113 139.57 146.369Z",
    fill: "#004E9A"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7214_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7214_8258)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7214_8258",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 85,
    width: 196,
    height: 196
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.019,
    cy: 182.973,
    r: 97.6601,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7214_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.9869 302.647C94.1512 303.35 92.1123 303.299 90.3137 302.507C88.5151 301.714 87.1023 300.243 86.3825 298.414C79.0854 279.895 79.2705 261.83 86.9216 246.175C96.3399 226.903 116.753 211.812 144.427 203.652C163.835 197.936 174.165 188.73 186.106 178.052C188.08 176.306 190.056 174.529 192.108 172.753C193.602 171.457 195.55 170.807 197.523 170.947C199.496 171.087 201.333 172.005 202.629 173.499C203.925 174.994 204.575 176.941 204.435 178.914C204.295 180.887 203.377 182.724 201.883 184.02C199.886 185.745 197.965 187.471 196.053 189.178C183.871 200.053 171.283 211.279 148.643 217.962C125.038 224.91 107.88 237.254 100.323 252.723C94.4059 264.712 94.4558 278.215 100.261 292.953C100.619 293.864 100.795 294.837 100.778 295.816C100.76 296.795 100.55 297.761 100.159 298.659C99.7686 299.557 99.2047 300.369 98.5 301.049C97.7953 301.729 96.9636 302.264 96.0523 302.622L95.9869 302.647Z",
    fill: "#004E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2337 161.3C83.8708 160.228 85.7852 159.658 87.7418 159.659C89.6984 159.66 91.6123 160.232 93.2484 161.305C94.8845 162.378 96.1718 163.906 96.9522 165.7C97.7327 167.494 97.9724 169.477 97.6419 171.406C95.7886 181.585 93.5922 189.998 91.6292 197.369C86.914 215.204 85.6032 221.822 91.0656 229.169C94.7666 233.481 98.8597 237.44 103.292 240.996C115.166 251.312 128.606 262.985 129.613 278.896C130.162 287.445 126.92 295.718 119.969 303.501C118.183 305.426 115.713 306.574 113.09 306.699C110.467 306.823 107.9 305.913 105.94 304.166C103.98 302.418 102.783 299.971 102.608 297.351C102.432 294.731 103.29 292.147 104.999 290.153C109.857 284.632 109.678 281.281 109.634 280.13C109.15 272.627 98.638 263.464 90.1845 256.122C84.6252 251.645 79.5381 246.612 75.0025 241.101C63.4696 225.565 67.3487 210.853 72.2768 192.218C74.1202 185.176 76.2337 177.182 77.9629 167.766C78.2074 166.458 78.7112 165.212 79.4447 164.101C80.1782 162.991 81.1264 162.038 82.2337 161.3Z",
    fill: "#004E9A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7214_8258",
    x: 218.295,
    y: 63.4219,
    width: 13.6699,
    height: 18.1698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.2253,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7214_8258"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7214_8258"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7214_8258",
    x: 268.006,
    y: 198.969,
    width: 9.94336,
    height: 14.4354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.2253,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7214_8258"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7214_8258"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_7214_8258",
    x: 51.3633,
    y: 53.0703,
    width: 10.7363,
    height: 15.2323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.2253,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7214_8258"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7214_8258"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_7214_8258",
    x: 236.539,
    y: 122.711,
    width: 10.7363,
    height: 15.2323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.2253,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7214_8258"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7214_8258"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_7214_8258",
    x: 179.359,
    y: 69.2578,
    width: 12.002,
    height: 17.0761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.2253,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7214_8258"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7214_8258"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7214_8258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278.387,
    height: 253.692,
    fill: "white",
    transform: "translate(0.804688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7214_8258"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.7656,
    y: 92.0469,
    width: 191.953,
    height: 191.953,
    rx: 95.9763,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7214_8258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.953,
    height: 41.5336,
    fill: "white",
    transform: "translate(18.7656 242.469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetworkImage);
export default __webpack_public_path__ + "static/media/no-network-image.5b3758bf23f0da92706603ec8ba771e6.svg";
export { ForwardRef as ReactComponent };